<template>
  <div>
    <form class="form-horizontal">
      <div class="mb-3">
        <fieldset>
          <legend>{{ $t('employee.contractInfo') }}</legend>
          <div class="row">
            <div class="col-md-12">
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="form-col-label control-label ts-text-xs">{{
                    $t('employee.contractStartDate')
                  }}</label>
                </div>
                <div class="col-md-9">
                  <DatePicker
                    style="width: 100%"
                    :value="model.contract_start_date"
                    placeholder="DD-MM-YYYY"
                    format="dd-MM-yyyy"
                    @on-change="onChangeContractStartDate"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="form-col-label control-label ts-text-xs">{{
                    $t('employee.period')
                  }}</label>
                </div>
                <div class="col-md-9">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter Contract Period (year)"
                    v-model="model.contract_period"
                    @input="getExpiryDate"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="form-col-label control-label ts-text-xs">{{
                    $t('employee.expiredate')
                  }}</label>
                </div>
                <div class="col-md-9">
                  <DatePicker
                    :value="model.contract_expire_date"
                    style="width: 100%"
                    placeholder="DD-MM-YYYY"
                    format="dd-MM-yyyy"
                    @on-change="onChangeContractExpiryDate"
                  ></DatePicker>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.numberOfWorkingDays') }}</label
                      >
                </div>
                <div class="col-md-3">
                  <input
                    type="number"
                    class="form-control"
                    v-model="model.number_of_working_days"
                  />
                </div>

                <div class="col-md-3">
                  <div class="ts-flex">
                    <label class="form-col-label control-label ts-text-xs ts-pr-3 ts-whitespace-no-wrap">
                            {{ $t('employee.startDay') }}</label>
                    <select class="form-control" v-model="model.start_day" style="width: 240px;">
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(weekDay, index) in weekDays"
                        :key="index"
                        :value="weekDay.value"
                        >{{ weekDay.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="ts-flex">
                    <label class="form-col-label control-label ts-text-xs ts-pr-3 ts-whitespace-no-wrap">
                            {{ $t('employee.endDay') }}</label
                          >
                    <select class="form-control" v-model="model.end_day" style="width: 240px;">
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(weekDay, index) in weekDays"
                        :key="index"
                        :value="weekDay.value"
                        >{{ weekDay.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mb-3">
        <fieldset>
          <legend>{{ $t('employee.employeeGuarantor') }}</legend>
          <div class="mb-3">
            <fieldset>
              <legend>{{ $t('employee.employeeGuarantor1') }}</legend>
              <div class="row">
                <div class="col-md-6">
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">{{
                        $t('employee.guarantorName')
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.guarantor_name"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter Guarantor Name')"
                        :class="{
                          'is-invalid': errors.has('guarantor_name')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor_name')"
                      >
                        {{ errors.first('guarantor_name') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.sex') }}</label
                      >
                    </div>
                    <div class="col-md-8">
                      <div class="ts-flex">
                        <div class="ts-justify-start">
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              id="male"
                              v-model="model.guarantor_sex"
                              value="Male"
                            />
                            <label class="form-check-label" for="male"
                              >Male</label
                            >
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              id="female"
                              v-model="model.guarantor_sex"
                              value="Female"
                            />
                            <label class="form-check-label" for="female"
                              >Female</label
                            >
                          </div>
                        </div>
                        <div class="ts-justify-end">
                          <input
                            v-model.trim="model.guarantor_age"
                            :placeholder="$t('employee.guarantorAge')"
                            type="number"
                            class="form-control"
                            :class="{
                              'is-invalid': errors.has('guarantor_age')
                            }"
                          />
                        </div>
                      </div>
                      <div
                        class="text-danger"
                        v-if="errors.has('guarantor_sex')"
                      >
                        {{ errors.first('guarantor_sex') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.ssnNo') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.guarantor_nid_number"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter Passport (Guarantor)')"
                        :class="{
                          'is-invalid': errors.has('guarantor_nid_number')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor_nid_number')"
                      >
                        {{ errors.first('guarantor_nid_number') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.nationality') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <select
                        v-model.number="model.nationality_id"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('nationality_id')
                        }"
                      >
                        <option :value="null">{{ $t('select') }}</option>
                        <option
                          v-for="(nationality, index) in nationalities"
                          :key="index"
                          :value="nationality.nationality_id"
                        >
                          {{ nationality.nationality_name_en }} ||
                          {{ nationality.nationality_name_kh }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('nationality_id')"
                      >
                        {{ errors.first('nationality_id') }}
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label contro-label ts-text-xs">
                        {{ $t('employee.relationship') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.relationship"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter Relationship')"
                        :class="{
                          'is-invalid': errors.has('relationship')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('relationship')"
                      >
                        {{ errors.first('relationship') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row mb-3">
                    <label
                      class="form-col-label control-label col-md-4 ts-text-xs"
                    >
                      {{ $t('employee.province') }}</label
                    >
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model="model.grt_province_code"
                        :class="{
                          'is-invalid': errors.has('grt_province_code')
                        }"
                        @change="grtProvinceChange(model.grt_province_code)"
                        @input="
                          model.grt_district_code =
                            model.grt_commune_code =
                            model.grt_village_code =
                              null
                        "
                      >
                        <option
                          :value="null"
                          disabled
                          selected
                          style="display: none"
                        >
                          {{ $t('select') }}
                        </option>
                        <option
                          v-for="(province, index) in provinces"
                          :key="index"
                          :value="province.province_code"
                        >
                          {{ province.name_en }} |
                          {{ province.name_kh }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label
                      class="form-col-label control-label col-md-4 ts-text-xs"
                    >
                      {{ $t('employee.district') }}</label
                    >
                    <div class="col-md-8">
                      <ts-loading-banner :loading="grt_province_change">
                        <select
                          class="form-control"
                          v-model="model.grt_district_code"
                          :class="{
                            'is-invalid': errors.has('grt_district_code')
                          }"
                          @change="grtDistrictChange(model.grt_district_code)"
                          @input="
                            model.grt_commune_code = model.grt_village_code =
                              null
                          "
                        >
                          <option
                            :value="null"
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(district, index) in grt_districts"
                            :key="index"
                            :value="district.district_code"
                          >
                            {{ district.name_en }} |
                            {{ district.name_kh }}
                          </option>
                        </select>
                      </ts-loading-banner>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.commune') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <ts-loading-banner :loading="grt_district_change">
                        <select
                          v-model="model.grt_commune_code"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('grt_commune_code')
                          }"
                          @change="grtCommuneChange(model.grt_commune_code)"
                          @input="model.grt_village_code = null"
                        >
                          <option
                            :value="null"
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(commune, index) in grt_communes"
                            :key="index"
                            :value="commune.commune_code"
                          >
                            {{ commune.name_en }} |
                            {{ commune.name_kh }}
                          </option>
                        </select>
                      </ts-loading-banner>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grt_commune_code')"
                      >
                        {{ errors.first('grt_commune_code') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.village') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <ts-loading-banner :loading="grt_commune_change">
                        <div class="input-group">
                          <select
                            v-model="model.grt_village_code"
                            class="form-control"
                            :class="{
                              'is-invalid': errors.has('grt_village_code')
                            }"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                              style="display: none"
                            >
                              {{ $t('select') }}
                            </option>
                            <option
                              v-for="(village, index) in grt_villages"
                              :key="index"
                              :value="village.village_code"
                            >
                              {{ village.name_en }} |
                              {{ village.name_kh }}
                            </option>
                          </select>
                          <Poptip
                            :title="$t('employee.village')"
                            :transfer="true"
                            width="240"
                            @on-popper-show="() => (name_en = name_kh = '')"
                            v-if="!villageSaving && model.commune_code"
                          >
                            <a
                              class="btn btn-info"
                              v-tooltip="$t('add')"
                              :disabled="villageSaving"
                            >
                              <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="villageSaving"
                              ></i>
                              <i class="fas fa-plus" v-else></i>
                            </a>
                            <div slot="content">
                              <div class="mb-2">
                                <label class="required">{{
                                  $t('employee.nameEn')
                                }}</label>
                                <input
                                  v-model.trim="name_en"
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': errors.has('name_en')
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.has('name_en')"
                                >
                                  {{ errors.first('name_en') }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <label class="required">{{
                                  $t('employee.nameKh')
                                }}</label>
                                <input
                                  v-model.trim="name_kh"
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': errors.has('name_kh')
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.has('name_kh')"
                                >
                                  {{ errors.first('name_kh') }}
                                </div>
                              </div>
                              <div class="tw-mt-2 tw-text-right">
                                <a
                                  class="ivu-btn ivu-btn-primary ivu-btn-small"
                                  @click.prevent="onSaveVillage"
                                >
                                  <span>Save</span>
                                </a>
                              </div>
                            </div>
                          </Poptip>
                          <a
                            class="btn btn-default"
                            v-tooltip="$t('add')"
                            :disabled="!model.commune_code"
                            v-else
                          >
                            <i
                              class="fas fa-circle-notch fa-spin"
                              v-if="villageSaving"
                            ></i>
                            <i class="fas fa-plus" v-else></i>
                          </a>
                        </div>
                      </ts-loading-banner>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grt_village_code')"
                      >
                        {{ errors.first('grt_village_code') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.houseNo') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.grt_house_no"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter House No')"
                        :class="{
                          'is-invalid': errors.has('grt_house_no')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grt_house_no')"
                      >
                        {{ errors.first('grt_house_no') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="mb-3">
            <fieldset>
              <legend>{{ $t('employee.employeeGuarantor2') }}</legend>
              <div class="row">
                <div class="col-md-6">
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">{{
                        $t('employee.guarantorName')
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.guarantor_name_2"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter Guarantor Name')"
                        :class="{
                          'is-invalid': errors.has('guarantor_name_2')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor_name_2')"
                      >
                        {{ errors.first('guarantor_name_2') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.sex') }}</label
                      >
                    </div>
                    <div class="col-md-8">
                      <div class="ts-flex">
                        <div class="ts-justify-start">
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              id="male2"
                              v-model="model.guarantor_sex_2"
                              value="Male"
                            />
                            <label class="form-check-label" for="male2"
                              >Male</label
                            >
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              id="female2"
                              v-model="model.guarantor_sex_2"
                              value="Female"
                            />
                            <label class="form-check-label" for="female2"
                              >Female</label
                            >
                          </div>
                        </div>
                        <div class="ts-justify-end">
                          <input
                            v-model.trim="model.guarantor_age_2"
                            :placeholder="$t('employee.guarantorAge')"
                            type="number"
                            class="form-control"
                            :class="{
                              'is-invalid': errors.has('guarantor_age_2')
                            }"
                          />
                        </div>
                      </div>
                      <div
                        class="text-danger"
                        v-if="errors.has('guarantor_sex')"
                      >
                        {{ errors.first('guarantor_sex') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.ssnNo') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.guarantor_nid_number_2"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter Passport (Guarantor)')"
                        :class="{
                          'is-invalid': errors.has('guarantor_nid_number_2')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor_nid_number_2')"
                      >
                        {{ errors.first('guarantor_nid_number_2') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.nationality') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <select
                        v-model.number="model.nationality_id_2"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('nationality_id_2')
                        }"
                      >
                        <option :value="null">{{ $t('select') }}</option>
                        <option
                          v-for="(nationality, index) in nationalities"
                          :key="index"
                          :value="nationality.nationality_id"
                        >
                          {{ nationality.nationality_name_en }} ||
                          {{ nationality.nationality_name_kh }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('nationality_id_2')"
                      >
                        {{ errors.first('nationality_id_2') }}
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label contro-label ts-text-xs">
                        {{ $t('employee.relationship') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model="model.relationship_2"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter Relationship')"
                        :class="{
                          'is-invalid': errors.has('relationship')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('relationship')"
                      >
                        {{ errors.first('relationship') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row mb-3">
                    <label
                      class="form-col-label control-label col-md-4 ts-text-xs"
                    >
                      {{ $t('employee.province') }}</label
                    >
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model="model.grt_province_code_2"
                        :class="{
                          'is-invalid': errors.has('grt_province_code_2')
                        }"
                        @change="
                          grtProvinceChange2(model.grt_province_code_2)
                        "
                        @input="
                          model.grt_district_code_2 =
                            model.grt_commune_code_2 =
                            model.grt_village_code_2 =
                              null
                        "
                      >
                        <option
                          :value="null"
                          disabled
                          selected
                          style="display: none"
                        >
                          {{ $t('select') }}
                        </option>
                        <option
                          v-for="(province, index) in provinces"
                          :key="index"
                          :value="province.province_code"
                        >
                          {{ province.name_en }} |
                          {{ province.name_kh }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label
                      class="form-col-label control-label col-md-4 ts-text-xs"
                    >
                      {{ $t('employee.district') }}</label
                    >
                    <div class="col-md-8">
                      <ts-loading-banner :loading="grt_province_change_2">
                        <select
                          class="form-control"
                          v-model="model.grt_district_code_2"
                          :class="{
                            'is-invalid': errors.has('grt_district_code_2')
                          }"
                          @change="
                            grtDistrictChange2(model.grt_district_code_2)
                          "
                          @input="
                            model.grt_commune_code_2 =
                              model.grt_village_code_2 = null
                          "
                        >
                          <option
                            :value="null"
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(district, index) in grt_districts_two"
                            :key="index"
                            :value="district.district_code"
                          >
                            {{ district.name_en }} |
                            {{ district.name_kh }}
                          </option>
                        </select>
                      </ts-loading-banner>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.commune') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <ts-loading-banner :loading="grt_district_change_2">
                        <select
                          v-model="model.grt_commune_code_2"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('grt_commune_code')
                          }"
                          @change="
                            grtCommuneChange2(model.grt_commune_code_2)
                          "
                          @input="model.grt_village_code_2 = null"
                        >
                          <option
                            :value="null"
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(commune, index) in grt_communes_two"
                            :key="index"
                            :value="commune.commune_code"
                          >
                            {{ commune.name_en }} |
                            {{ commune.name_kh }}
                          </option>
                        </select>
                      </ts-loading-banner>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grt_commune_code')"
                      >
                        {{ errors.first('grt_commune_code') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.village') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <ts-loading-banner :loading="grt_commune_change_2">
                        <div class="input-group">
                          <select
                            v-model="model.grt_village_code_2"
                            class="form-control"
                            :class="{
                              'is-invalid': errors.has('grt_village_cod2')
                            }"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                              style="display: none"
                            >
                              {{ $t('select') }}
                            </option>
                            <option
                              v-for="(village, index) in grt_village_two"
                              :key="index"
                              :value="village.village_code"
                            >
                              {{ village.name_en }} |
                              {{ village.name_kh }}
                            </option>
                          </select>
                          <Poptip
                            :title="$t('employee.village')"
                            :transfer="true"
                            width="240"
                            @on-popper-show="() => (name_en = name_kh = '')"
                            v-if="!villageSaving && model.commune_code"
                          >
                            <a
                              class="btn btn-info"
                              v-tooltip="$t('add')"
                              :disabled="villageSaving"
                            >
                              <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="villageSaving"
                              ></i>
                              <i class="fas fa-plus" v-else></i>
                            </a>
                            <div slot="content">
                              <div class="mb-2">
                                <label class="required">{{
                                  $t('employee.nameEn')
                                }}</label>
                                <input
                                  v-model.trim="name_en"
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': errors.has('name_en')
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.has('name_en')"
                                >
                                  {{ errors.first('name_en') }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <label class="required">{{
                                  $t('employee.nameKh')
                                }}</label>
                                <input
                                  v-model.trim="name_kh"
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': errors.has('name_kh')
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.has('name_kh')"
                                >
                                  {{ errors.first('name_kh') }}
                                </div>
                              </div>
                              <div class="tw-mt-2 tw-text-right">
                                <a
                                  class="ivu-btn ivu-btn-primary ivu-btn-small"
                                  @click.prevent="onSaveVillage"
                                >
                                  <span>Save</span>
                                </a>
                              </div>
                            </div>
                          </Poptip>
                          <a
                            class="btn btn-default"
                            v-tooltip="$t('add')"
                            :disabled="!model.commune_code"
                            v-else
                          >
                            <i
                              class="fas fa-circle-notch fa-spin"
                              v-if="villageSaving"
                            ></i>
                            <i class="fas fa-plus" v-else></i>
                          </a>
                        </div>
                      </ts-loading-banner>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grt_village_code')"
                      >
                        {{ errors.first('grt_village_code') }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-col-label control-label ts-text-xs">
                        {{ $t('employee.houseNo') }}
                      </label>
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="model.grt_house_no_2"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Enter House No')"
                        :class="{
                          'is-invalid': errors.has('grt_house_no_2')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grt_house_no_2')"
                      >
                        {{ errors.first('grt_house_no_2') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </fieldset>
      </div>
      <div class="mb-3">
        <fieldset>
          <legend class="text-blue">
            Contract Attachments/ឯកសារភ្ជាប់កិច្ចសន្យា
          </legend>
          <div class="row">
            <div class="col-md-12 tw-h-48">
              <VueFileAgent
                ref="vueFileAgent"
                :theme="'default'"
                :multiple="true"
                :deletable="true"
                :meta="true"
                :linkable="true"
                :accept="'image/*,video/*,.pdf,.doc,.docx,.ods'"
                :maxSize="'10MB'"
                :maxFiles="14"
                :helpText="'Choose images or files'"
                :errorText="{
                  type: 'Invalid file type.',
                  size: 'Files should not exceed 10MB in size'
                }"
                @select="filesSelected($event)"
                @beforedelete="onBeforeDelete($event)"
                v-model="fileRecords"
              ></VueFileAgent>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh">
        <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">
          {{ $t('cancel') }}</ts-button
        >
        <ts-button
          color="info"
          outline
          :waiting="save_previewing"
          :disabled="save_previewing || waiting"
          @click.prevent="onSavePreview"
        >
          {{ $t('employee.savePreviewContract') }}</ts-button
        >
        <ts-button
          @click.prevent="onSave"
          color="primary"
          :waiting="waiting"
          :disabled="waiting || save_previewing"
          class="btn btn-primary d-block"
        >
          {{ $t('save') }}</ts-button
        >
      </div>
      <Spin size="large" fix v-if="loading"> </Spin>
    </form>
    <a-modal
      v-model="show"
      sticky
      scrollable
      :mask="false"
      :footer="null"
      :z-index="1022"
      :closable="true"
      width="70%"
      :title="$t('previewPdf')"
    >
      <div class="demo-spin-article">
        <div id="container">
          <ts-preview-pdf :src="src" />
        </div>
      </div>
      <Spin size="large" fix v-if="save_previewing"> </Spin>
    </a-modal>
  </div>
</template>
<script>
import VueFileAgent from 'vue-file-agent'
Vue.use(VueFileAgent)
import Vue from 'vue'
import httpClient from '@/http-client'
import 'vue-file-agent/dist/vue-file-agent.css'

import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { isEmpty, forEach } from 'lodash'
import moment from 'moment'


export default {
  name: 'addOrRenewContractInfo',
  data () {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      save_previewing: false,
      show: false,
      fileRecords: [],
      fileRecordsForUpload: [],
      uploadUrl: process.env.VUE_APP_PROXY + '/api/v1/employees/upload-files',
      uploadHeaders: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-Test-Header': 'vue-file-agent',
        Authorization: 'Bearer ' + this.$store.state.accessToken
      },
      model: {
        contract_id: null,
        employee_id: null,
        contract_period: null,
        contract_expire_date: null,
        contract_start_date: moment().format('DD-MM-YYYY'),
        guarantor_name: null,
        guarantor_sex: null,
        guarantor_age: null,
        nationality_id: null,
        guarantor_nid_number: null,
        relationship: null,
        grt_village_code: null,
        grt_commune_code: null,
        grt_district_code: null,
        grt_province_code: null,
        grt_house_no: null,
        guarantor_name_2: null,
        guarantor_sex_2: null,
        guarantor_age_2: null,
        nationality_id_2: null,
        guarantor_nid_number_2: null,
        relationship_2: null,
        grt_village_code_2: null,
        grt_commune_code_2: null,
        grt_district_code_2: null,
        grt_province_code_2: null,
        grt_house_no_2: null,
        start_day: null,
        end_day: null,
        number_of_working_days: null,
        attached_file: []
      },
      province_change: false,
      district_change: false,
      commune_change: false,
      districts: [],
      communes: [],
      villages: [],
      grt_province_change: false,
      grt_district_change: false,
      grt_commune_change: false,
      grt_district_change_2: false,
      grt_province_change_2: false,
      grt_commune_change_2: false,
      grt_districts: [],
      grt_districts_two: [],
      grt_communes: [],
      grt_communes_two: [],
      grt_villages: [],
      grt_village_two: [],
      villageSaving: false,
      name_en: null,
      name_kh: null,
      marritalStatus: ['នៅលីវ', 'រៀបការ', 'មេម៉ាយ', 'ពោះម៉ាយ'],
      src: ''
    }
  },
  computed: {
    ...mapState('humanResource/employee', [
      'provinces',
      'nationalities',
      'edit_data'
    ]),
    weekDays () {
      return [
        { text: this.$t('employee.monday'), value: 1 },
        { text: this.$t('employee.tuesday'), value: 2 },
        { text: this.$t('employee.wednesday'), value: 3 },
        { text: this.$t('employee.thursday'), value: 4 },
        { text: this.$t('employee.friday'), value: 5 },
        { text: this.$t('employee.saturday'), value: 6 },
        { text: this.$t('employee.sunday'), value: 7 }
      ]
    },
  },
  validations: {
    name_en: { required },
    name_kh: { required },
    villageForm: ['name_en', 'name_kh']
  },
  created () {
    this.fetchResource()
  },
  methods: {
    ...mapActions('humanResource/employee', [
      'getNationality',
      'getProvince',
      'getDistrict',
      'getCommune',
      'getVillage',
      'attachFile'
    ]),
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        fileRecord => !fileRecord.error
      )
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords)
      this.uploadFiles()
    },
    uploadFiles: function () {
      forEach(this.fileRecordsForUpload, f => {
        let frm = new FormData()
        frm.append('file', f.file)
        httpClient
          .post('/api/v1/employees/upload-files', frm, {
            onUploadProgress: el => {
              if (el.lengthComputable) {
                f.progressing = Math.round((el.loaded * 100) / el.total)
              }
            }
          })
          .then(response => {
            this.model.attached_file.push({
              attached_file_name: response.data.attached_file_name,
              attached_file: response.data.attached_file,
              mime_type: response.data.mime_type,
              attachment_id: null,
              contract_id: null,
              size: null
            })
          })
      })

      this.fileRecordsForUpload = []
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        var k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.fileDeleted(fileRecord)
          // this.$refs.vueFileAgent.deleteFileRecord(fileRecord)
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      var j = this.fileRecords.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.fileRecords.splice(j, 1)
        if (fileRecord.file) {
          let item = this.attached_file.find(
            el => el.attached_file_name == fileRecord.file.name
          )
          let file_index = this.attached_file.indexOf(
            ...this.attached_file.filter(
              f => f.attached_file_name == item.attached_file_name
            )
          )
          this.attached_file.splice(file_index, 1)
        } else {
          let item = this.attached_file.find(
            f => f.attached_file == fileRecord.url
          )
          let file_index = this.attached_file.indexOf(
            ...this.attached_file.filter(
              f => f.attached_file == item.attached_file
            )
          )
          this.attached_file.splice(file_index, 1)
        }
      }
    },
    async fetchResource () {
      this.errors = new Errors()
      this.loading = true
      this.clear()
      await this.getNationality()
      await this.getProvince()
      this.loading = false
    },

    onSave () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'humanResource/employee/storeContract',
          Object.assign({}, this.model, {
            is_save_preview: false
          })
        )
        .then(response => {
          this.notice({
            type: 'success',
            text: response.message
          })
          this.$emit('cancel')
          this.$emit('fetchData')
          this.clear()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSavePreview () {
      this.show = true
      this.errors = new Errors()
      this.save_previewing = true
      this.$store
        .dispatch(
          'humanResource/employee/storeContract',
          Object.assign({}, this.model, {
            is_save_preview: true
          })
        )
        .then(response => {
          this.$emit('cancel')
          this.$emit('fetchData')
          this.clear()
          this.src = response.url
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.save_previewing = false
        })
    },
    async getProvince () {
      this.loading = true
      await this.$store
        .dispatch('humanResource/employee/getProvince')
        .then(() => {
          this.setEditData()
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
    provinceChange (province_code) {
      this.province_change = true
      this.getDistrict(province_code)
        .then(response => {
          this.districts = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.province_change = false
        })
    },

    districtChange (district_code) {
      this.district_change = true
      this.getCommune(district_code)
        .then(response => {
          this.communes = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.district_change = false
        })
    },

    communeChange (commune_code) {
      this.commune_change = true
      this.getVillage(commune_code)
        .then(response => {
          this.villages = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.commune_change = false
        })
    },
    grtProvinceChange (province_code) {
      this.grt_province_change = true
      this.getDistrict(province_code)
        .then(response => {
          this.grt_districts = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.grt_province_change = false
        })
    },
    grtDistrictChange (district_code) {
      this.grt_district_change = true
      this.getCommune(district_code)
        .then(response => {
          this.grt_communes = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.grt_district_change = false
        })
    },
    grtCommuneChange (commune_code) {
      this.grt_commune_change = true
      this.getVillage(commune_code)
        .then(response => {
          this.grt_villages = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.grt_commune_change = false
        })
    },
    grtProvinceChange2 (province_code) {
      this.grt_province_change_2 = true
      this.getDistrict(province_code)
        .then(response => {
          this.grt_districts_two = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.grt_province_change_2 = false
        })
    },
    grtDistrictChange2 (district_code) {
      this.grt_district_change_2 = true
      this.getCommune(district_code)
        .then(response => {
          this.grt_communes_two = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.grt_district_change_2 = false
        })
    },

    grtCommuneChange2 (commune_code) {
      this.grt_commune_change_2 = true
      this.getVillage(commune_code)
        .then(response => {
          this.grt_village_two = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.grt_commune_change_2 = false
        })
    },
    async onSaveVillage () {
      this.$v.villageForm.$touch()
      if (this.$v.villageForm.$invalid) return

      this.villageSaving = true
      this.$store
        .dispatch('humanResource/employee/addVillage', {
          name_en: this.name_en,
          name_kh: this.name_kh,
          commune_code: this.model.commune_code
        })
        .then(response => {
          this.villages.push({
            name_en: response.resource.name_en,
            name_kh: response.resource.name_kh,
            village_code: response.resource.village_code
          })
          this.model.village_code = response.resource.village_code
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.villageSaving = false
          this.name_en = ''
          this.name_kh = ''
        })
    },

    onChangeContractStartDate (date) {
      this.model.contract_start_date = date
      this.getExpiryDate
    },
    getExpiryDate () {
      this.model.contract_expire_date = moment(
        moment(this.model.contract_start_date, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        )
      )
        .add(this.model.contract_period, 'years')
        .format('DD-MM-YYYY')
    },
    onChangeContractExpiryDate (date) {
      this.model.contract_expire_date = date
    },
    async setEditData () {
      if (!isEmpty(this.edit_data)) {
        this.model.employee_id = this.edit_data.employee_id
        this.model.contract_start_date = this.edit_data.hire_date
        if (!isEmpty(this.edit_data.contract)) {
          if (this.edit_data.contract.grt_province_code) {
            this.grtProvinceChange(this.edit_data.contract.grt_province_code)
          }
          if (this.edit_data.contract.grt_district_code) {
            this.grtDistrictChange(this.edit_data.contract.grt_district_code)
          }
          if (this.edit_data.contract.grt_commune_code) {
            this.grtCommuneChange(this.edit_data.contract.grt_commune_code)
          }
          this.model.contract_start_date = this.edit_data.contract.contract_expire_date  
          this.model.grt_province_code = this.edit_data.contract.grt_province_code  
          this.model.grt_district_code = this.edit_data.contract.grt_district_code
          this.model.grt_commune_code = this.edit_data.contract.grt_commune_code
          this.model.grt_village_code = this.edit_data.contract.grt_village_code
          this.model.guarantor_name = this.edit_data.contract.guarantor_name
          this.model.guarantor_sex = this.edit_data.contract.guarantor_sex
          this.model.guarantor_age = this.edit_data.contract.guarantor_age
          this.model.guarantor_nid_number =
            this.edit_data.contract.guarantor_nid_number
          this.model.nationality_id = this.edit_data.contract.nationality_id
          this.model.relationship = this.edit_data.contract.relationship
          this.model.grt_house_no = this.edit_data.contract.grt_house_no
        }
        if (!isEmpty(this.edit_data.contract)) {
          if (this.edit_data.contract.grt_province_code_2) {
            this.grtProvinceChange2(this.edit_data.contract.grt_province_code_2)
          }
          if (this.edit_data.contract.grt_district_code_2) {
            this.grtDistrictChange2(this.edit_data.contract.grt_district_code_2)
          }
          if (this.edit_data.contract.grt_commune_code_2) {
            this.grtCommuneChange2(this.edit_data.contract.grt_commune_code_2)
          }
          this.model.grt_province_code_2 =
            this.edit_data.contract.grt_province_code_2
          this.model.grt_district_code_2 =
            this.edit_data.contract.grt_district_code_2
          this.model.grt_commune_code_2 =
            this.edit_data.contract.grt_commune_code_2
          this.model.grt_village_code_2 =
            this.edit_data.contract.grt_village_code_2
          this.model.guarantor_name_2 = this.edit_data.contract.guarantor_name_2
          this.model.guarantor_sex_2 = this.edit_data.contract.guarantor_sex_2
          this.model.guarantor_age_2 = this.edit_data.contract.guarantor_age_2
          this.model.nationality_id_2 = this.edit_data.contract.nationality_id_2
          this.model.relationship_2 = this.edit_data.contract.relationship_2
          this.model.grt_house_no_2 = this.edit_data.contract.grt_house_no_2
          this.model.start_day = this.edit_data.contract.start_day
          this.model.end_day = this.edit_data.contract.end_day
          this.model.number_of_working_days = this.edit_data.contract.number_of_working_days
        }
      }
    },

    clear () {
      this.model = {
        contract_id: null,
        employee_id: null,
        contract_period: null,
        contract_expire_date: null,
        contract_start_date: moment().format('DD-MM-YYYY'),
        guarantor_name: null,
        guarantor_sex: null,
        guarantor_age: null,
        nationality_id: null,
        guarantor_nid_number: null,
        relationship: null,
        grt_village_code: null,
        grt_commune_code: null,
        grt_district_code: null,
        grt_province_code: null,
        grt_house_no: null,
        guarantor_name_2: null,
        guarantor_sex_2: null,
        guarantor_age_2: null,
        nationality_id_2: null,
        guarantor_nid_number_2: null,
        relationship_2: null,
        grt_village_code_2: null,
        grt_commune_code_2: null,
        grt_district_code_2: null,
        grt_province_code_2: null,
        grt_house_no_2: null,
        start_day: null,
        end_day: null,
        number_of_working_days: null,
        attached_file: [],
      }
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'EMPLOYEE',
        desc: not.text
      })
    }
  },
  watch: {
    edit_data: function () {
      this.fetchResource()
    }
  }
}
</script>
